import { gql } from '@apollo/client'
import { SABRE_FLAVOR_FRAGMENT } from '../fragments/FlavorFragment'

export const SABRE_GET_FLAVORS = gql`
  query GetFlavors($input: FlavorsInput) {
    flavors(input: $input) {
      hasMore
      count
      results {
        ...Flavor
      }
    }
  }
  ${SABRE_FLAVOR_FRAGMENT}
`
